import { useUrlParams } from './useUrlParams';

const toArray = (item?: string | string[]) => (Array.isArray(item) ? item : item ? [item] : []);

export const usePLPPinnedVariantIdVariables = () => {
  const { params } = useUrlParams();
  const ids = toArray(params.pinned_variant_ids);

  if (ids.length === 0) return null;

  return {
    ruleContexts: ['pinned_variants'],
    rules: [
      {
        conditions: [
          {
            alternatives: false,
            anchoring: 'is',
            context: 'pinned_variants_preview',
            pattern: ''
          }
        ],
        consequence: {
          filterPromotes: true,
          promote: ids.map((id, index) => ({ objectIDs: [`201-${id}`], position: index }))
        },
        enabled: true,
        objectID: 'pinned_variants'
      }
    ]
  };
};
